.labelWrapper {
  display: inline-flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  user-select: none;
  font-weight: normal;
  height: 32px;
}

.labelWrapper input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.checkmark {
  position: absolute;
  top: 5px;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: var(--white);
  border: 1px solid #787878;
  border-radius: 50%;
}

.labelWrapper input:checked ~ .checkmark {
  background-color: var(--white);
}

.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

.disabled {
  cursor: not-allowed;
}

.labelWrapper input:checked ~ .checkmark:after {
  display: block;
}

.labelWrapper .checkmark:after {
  top: 3px;
  left: 3px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: var(--black);
}

.label {
  margin-left: 41px;
  font-size: 14px;
  font-weight: 600;
  color: var(--gray-darker);
}
